export default __webpack_public_path__ + "static/media/tool-icon-hoop.0d9c6a09.svg";